import _ from 'lodash';
import {
	FETCH_ALL_BRANDS_FULFILLED,
	SELECT_BRAND,
	UPDATE_BRAND_FULFILLED
} from '../actions/BrandsCreators';

export const BrandsReducer = (state = {
	brandList: {},
	selectBrand: []
}, action) => {
	switch (action.type) {
		case FETCH_ALL_BRANDS_FULFILLED:
			const newState = {
				...state,
				brandList: _.mapKeys(action.payload.data.brands, 'id')
			};
			return newState;
		case SELECT_BRAND:
			return {
				...state,
				selectBrand: action.payload
			};
		case UPDATE_BRAND_FULFILLED:
			return {
				...state,
				brandList: {
					...state.brandList,
					[action.payload.id]: action.payload,
				}
			}
		default:
	}
	return state;
}
